import PropTypes from "prop-types"
import React from "react"
import { Row, Col, Card, CardBody, Container, Label } from "reactstrap"
import { Formik, Form, Field, ErrorMessage } from "formik"

//redux
import { useSelector, useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// import images
import logo from "../../assets/images/logo.svg"
import { resetPasswordSchema } from "components/Common/validation"
import { forgotPassword } from "store/actions/authAction"
import { showAlert } from "store/reducers/alertReducer"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"

const ForgetPasswordPage = props => {
  const { t } = useTranslation()

  //meta title
  document.title = t("Forget Password | Namq")

  const dispatch = useDispatch()
  const { loading, error, forgetError, forgetSuccessMsg, actionType } =
    useSelector(state => state.Login)

  // const { forgetSuccessMsg } = useSelector(ForgotPasswordProperties)

  const onSubmit = values => {
    dispatch(forgotPassword({ ...values, history: props.router.navigate }))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col xs={12}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">{t("Welcome Back")} !</h5>
                        <p>{t("Sign in to continue to Namq.")}</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span
                          className="avatar-title bg-light"
                          style={{ borderRadius: 10, padding: 10 }}
                        >
                          <img
                            src={logo}
                            alt=""
                            className="img-fluid"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{ email: "" }}
                      validationSchema={resetPasswordSchema}
                      onSubmit={onSubmit}
                    >
                      {({ values, errors, touched, isSubmitting }) => (
                        <Form className="form-horizontal">
                          <div className="mb-3">
                            <Label className="form-label">{t("Email")}</Label>
                            <Field
                              name="email"
                              className={`form-control ${
                                touched.email && errors.email && "is-invalid"
                              }`}
                              placeholder={t("Email")}
                              type="email"
                            />
                            <TextError name="email" />
                          </div>
                          <Row className="mb-3">
                            <Col className="text-end">
                              <button
                                className="btn btn-primary w-md "
                                type="submit"
                                disabled={loading}
                              >
                                {t("Reset")}
                              </button>
                            </Col>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {t("Go back to")}{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    {t("Login")}
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} {t("Namq")}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default withRouter(ForgetPasswordPage)
